import { Card, Group, Skeleton, Stack, Text, ThemeIcon } from "@mantine/core";
import type { ReactNode } from "react";

type Tone = "neutral" | "ok" | "warning" | "alarm";
const TONE: Record<Tone, string> = { neutral: "brand", ok: "teal", warning: "yellow", alarm: "red" };

/** A KPI: a label, a big number with its unit, a line or two under it, an icon. */
export function StatCard({
  label,
  value,
  unit,
  secondary,
  extra,
  icon,
  tone = "neutral",
  loading = false,
  valueTestId,
  testId,
}: {
  label: string;
  value: ReactNode;
  unit?: string;
  secondary?: ReactNode;
  extra?: ReactNode;
  icon?: ReactNode;
  tone?: Tone;
  loading?: boolean;
  valueTestId?: string;
  testId?: string;
}) {
  return (
    <Card padding="md" data-testid={testId}>
      <Group justify="space-between" align="flex-start" wrap="nowrap" gap="xs">
        <Stack gap={6} style={{ minWidth: 0 }}>
          <Text className="sv-eyebrow">{label}</Text>
          {loading ? (
            <Skeleton h={28} w={120} />
          ) : (
            <Text component="div" className="sv-kpi-value" data-testid={valueTestId}>
              {value}
              {unit !== undefined && (
                <>
                  {" "}
                  <Text span fz={14} fw={500} c="dimmed">
                    {unit}
                  </Text>
                </>
              )}
            </Text>
          )}
          {secondary !== undefined && (
            <Text size="xs" c="dimmed" component="div">
              {secondary}
            </Text>
          )}
          {extra}
        </Stack>
        {icon !== undefined && (
          <ThemeIcon variant="light" color={TONE[tone]} size={36} radius="md">
            {icon}
          </ThemeIcon>
        )}
      </Group>
    </Card>
  );
}
